import { defineComponent as _defineComponent } from 'vue'
import BCXDatePicker from '@/components/molecules/forms/datepicker/BCXDatePicker.vue';
import { onMounted } from 'vue';
import MeetingSectionItem from '@/components/meeting-scheduler/components/MeetingSectionItem.vue';
import MeetingSection from '@/components/meeting-scheduler/components/MeetingSection.vue';
import useMeetingScheduler from '@/components/meeting-scheduler/composables/useMeetingScheduler';
import { AppointmentEntry, InvitationOverview } from '@/models/MeetingScheduler';
import useI18n from '@/mixins/useI18n';
import { isEmpty } from 'lodash';
import useFormattedDateTime from '@/mixins/useFormattedDateTime';
import MeetingLoading from '@/components/meeting-scheduler/components/MeetingLoading.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MeetingCalendar',
  setup(__props) {

const { t } = useI18n();
const { getFormattedDate, getFormattedTimeRange } = useFormattedDateTime();

const {
  calendarData, mode, selectedDate, selectedItem, hasAppointment, refreshCalendar, selectedAppointments, isCalendarLoading, pickerYearRange, showMeeting, openSearch
} = useMeetingScheduler();

const today = new Date();

function onSelectItem(appointment: AppointmentEntry | InvitationOverview) {
  if (mode.value === 'VIEW' && selectedItem.value?.meetingId === appointment.meetingId) return;
  showMeeting(appointment);
}

onMounted(() => refreshCalendar());

return { __sfc: true,t, getFormattedDate, getFormattedTimeRange, calendarData, mode, selectedDate, selectedItem, hasAppointment, refreshCalendar, selectedAppointments, isCalendarLoading, pickerYearRange, showMeeting, openSearch, today, onSelectItem, BCXDatePicker, MeetingSectionItem, MeetingSection, isEmpty, MeetingLoading }
}

})